import { getCampaignsStore } from '@api/store/campaigns/actions';
import { SimplePopoverPlainOption } from '@dev/ee-components';
import { isEmpty } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
/**
 *
 * @returns object with all campaigns for given time range
 */
export const useCampaignPopoverOptions = (): SimplePopoverPlainOption[] => {
    const { t } = useTranslation();
    const { campaignsList } = useSelector(getCampaignsStore);

    if (isEmpty(campaignsList)) {
        return [];
    }

    const userCampaigns = campaignsList?.map((el) => ({
        value: el.Name,
        label: el.Name,
    }));

    return [{ value: 'all', label: t('all') }, ...userCampaigns];
};
